import { useNavigate } from "react-router-dom";
import { Text } from "../Text/Text";
import styles from "./Card.module.scss";

export const Card = ({ href, title, src }) => {
  const navigate = useNavigate();

  return (
    <div onClick={() => navigate(href)} className={styles.container}>
      <div>
        <img src={src} className={styles.imgCover} />
      </div>
      <div className={styles.truncate}>
      <Text className={styles.text} bold color="white">
        {title}
      </Text>
      </div>
    </div>
  );
};
